import { IContext } from "@src/context";
import { resolveUrl } from "@src/utils/baseUrl";
import { IProperty } from "./types";
import messages from "./messages";

export function renderSlides(
  context: IContext,
  properties: IProperty[]
): string[] {
  const { intl } = context;

  return properties.map((property) => {
    return `<div class="swiper-slide">
    <div class="container-shortlist-item">
      <div class="container-shortlist-item-image">
        <a href="${property.detailLink || ""}">
          <picture>
            ${
              property.img?.webp
                ? `<source type="image/webp" srcset="${resolveUrl(
                    property.img.webp
                  )}"></source>`
                : ""
            }
            <img src="${
              property.img?.orig
                ? resolveUrl(property.img.orig)
                : resolveUrl("/static/images/default.jpg")
            }"></img>
          </picture>
        </a>
        <div
          class="container-shortlist-favorite"
          data-favorite="true"
          data-property-id="${property.id?.toString() || ""}"
        ></div>
      </div>
      <div class="container-shortlist-item-info">
        <h5 class="container-shortlist-item-name h5">${property.name}</h5>
        <div class="container-shortlist-item-address">${property.addr}</div>
        <a class="container-shortlist-item-link" href="${
          property.detailLink || ""
        }">${intl.formatMessage(messages.detailButton)}</a>
      </div>
    </div>
  </div>`;
  });
}
